export const OPEN_PASSKEY_MANAGEMENT_DRAWER = 'OPEN_PASSKEY_MANAGEMENT_DRAWER';
export const CLOSE_PASSKEY_MANAGEMENT_DRAWER = 'CLOSE_PASSKEY_MANAGEMENT_DRAWER';

const open = employeeId => ({
  type: OPEN_PASSKEY_MANAGEMENT_DRAWER,
  payload: employeeId,
});

const close = () => ({
  type: CLOSE_PASSKEY_MANAGEMENT_DRAWER,
});

export default { open, close };
